import { ReactElement } from 'react';

const Calendar = (): ReactElement => (
  <div>This is the calendar page</div>
);

export default Calendar;
